import { RefObject, useEffect, ForwardedRef } from 'react'

import { useForwardRef } from 'src/hook/useForwardRef'

import { styles } from '../../styles'

export const useDatePickerRef = <T extends HTMLElement>(
  forwardedRef: ForwardedRef<T>
): { ref: RefObject<T> } => {
  const ref = useForwardRef<T>(forwardedRef)

  useEffect(() => {
    if (ref?.current) {
      const datePickerStyles = document.createElement('style')
      datePickerStyles.prepend(styles.toString())
      ref?.current?.shadowRoot?.prepend(datePickerStyles)
    }
  }, [ref])

  return { ref }
}
